import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import Tag from '../Tag/Tag';
import Input from '../Input';
import InputSuffix from '../Input/InputSuffix';
import styles from './InputWithTags.scss';
import classNames from 'classnames';
import isUndefined from 'lodash/isUndefined';
import SortableList from '../SortableList/SortableList';
import defaultDndStyles from '../dnd-styles';

var InputWithTags = /*#__PURE__*/function (_React$Component) {
  _inherits(InputWithTags, _React$Component);

  var _super = _createSuper(InputWithTags);

  function InputWithTags(props) {
    var _this;

    _classCallCheck(this, InputWithTags);

    _this = _super.call(this, props);
    _this.focus = _this.focus.bind(_assertThisInitialized(_this));
    _this.blur = _this.blur.bind(_assertThisInitialized(_this));
    _this.select = _this.select.bind(_assertThisInitialized(_this));
    _this.renderReorderableTag = _this.renderReorderableTag.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleInputFocus = _this.handleInputFocus.bind(_assertThisInitialized(_this));
    _this.handleInputBlur = _this.handleInputBlur.bind(_assertThisInitialized(_this));
    _this.state = {
      inputValue: '',
      inputHasFocus: false
    };
    return _this;
  }

  _createClass(InputWithTags, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.autoFocus && this.props.onFocus();
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      if (!this.props.disabled) {
        this.input.focus();
        this.props.onInputClicked && this.props.onInputClicked(e);
      }
    }
  }, {
    key: "handleInputFocus",
    value: function handleInputFocus(e) {
      !this.state.inputHasFocus && this.setState({
        inputHasFocus: true
      });
      this.props.onFocus && this.props.onFocus(e);
    }
  }, {
    key: "handleInputBlur",
    value: function handleInputBlur(e) {
      this.state.inputHasFocus && this.setState({
        inputHasFocus: false
      });
      this.props.onBlur && this.props.onBlur(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _classNames2,
          _this2 = this;

      var _this$props = this.props,
          tags = _this$props.tags,
          onRemoveTag = _this$props.onRemoveTag,
          onReorder = _this$props.onReorder,
          placeholder = _this$props.placeholder,
          status = _this$props.status,
          statusMessage = _this$props.statusMessage,
          disabled = _this$props.disabled,
          delimiters = _this$props.delimiters,
          mode = _this$props.mode,
          inputProps = _objectWithoutProperties(_this$props, ["tags", "onRemoveTag", "onReorder", "placeholder", "status", "statusMessage", "disabled", "delimiters", "mode"]);

      var hasFocus = this.state.inputHasFocus;
      var isSelectMode = mode === 'select';
      var className = classNames((_classNames = {}, _defineProperty(_classNames, styles.inputWithTagsContainer, true), _defineProperty(_classNames, styles.disabled, disabled), _defineProperty(_classNames, styles[status], status), _defineProperty(_classNames, styles.readOnly, isSelectMode), _defineProperty(_classNames, styles.hasFocus, hasFocus && !disabled), _defineProperty(_classNames, styles.hasMaxHeight, !isUndefined(this.props.maxHeight) || !isUndefined(this.props.maxNumRows)), _classNames));
      /* eslint-disable no-unused-vars */

      var onManuallyInput = inputProps.onManuallyInput,
          inputElement = inputProps.inputElement,
          closeOnSelect = inputProps.closeOnSelect,
          predicate = inputProps.predicate,
          onClickOutside = inputProps.onClickOutside,
          fixedHeader = inputProps.fixedHeader,
          fixedFooter = inputProps.fixedFooter,
          dataHook = inputProps.dataHook,
          onFocus = inputProps.onFocus,
          withSelection = inputProps.withSelection,
          onBlur = inputProps.onBlur,
          menuArrow = inputProps.menuArrow,
          onInputClicked = inputProps.onInputClicked,
          size = inputProps.size,
          desiredProps = _objectWithoutProperties(inputProps, ["onManuallyInput", "inputElement", "closeOnSelect", "predicate", "onClickOutside", "fixedHeader", "fixedFooter", "dataHook", "onFocus", "withSelection", "onBlur", "menuArrow", "onInputClicked", "size"]);

      var suffixStyles = classNames(styles.inputSuffix, (_classNames2 = {}, _defineProperty(_classNames2, styles.sizeSmall, size === 'small'), _defineProperty(_classNames2, styles.sizeLarge, size === 'large'), _classNames2));
      var rowMultiplier;

      if (tags.length && tags[0].size === 'large') {
        rowMultiplier = 47;
      } else {
        rowMultiplier = 35;
      }

      var maxHeight = this.props.maxHeight || this.props.maxNumRows * rowMultiplier || 'initial';
      return /*#__PURE__*/React.createElement("div", {
        className: className,
        "data-status": status,
        style: {
          maxHeight: maxHeight
        },
        onClick: this.handleClick,
        "data-hook": this.props.dataHook
      }, onReorder ? /*#__PURE__*/React.createElement(SortableList, {
        contentClassName: styles.tagsContainer,
        items: tags,
        onDrop: onReorder,
        renderItem: this.renderReorderableTag
      }) : tags.map(function (_ref) {
        var label = _ref.label,
            rest = _objectWithoutProperties(_ref, ["label"]);

        return /*#__PURE__*/React.createElement(Tag, _extends({
          key: rest.id,
          dataHook: "tag",
          disabled: disabled,
          onRemove: onRemoveTag,
          className: styles.tag
        }, rest), label);
      }), /*#__PURE__*/React.createElement("span", {
        className: classNames(styles.input, !tags.length),
        "data-hook": "inner-input-with-tags"
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames(styles.hiddenDiv, _defineProperty({}, styles.smallFont, size === 'small'))
      }, this.state.inputValue), /*#__PURE__*/React.createElement(Input, _extends({
        size: size,
        width: this.props.width,
        ref: function ref(input) {
          return _this2.input = input;
        },
        onFocus: this.handleInputFocus,
        onBlur: this.handleInputBlur,
        placeholder: tags.length === 0 ? placeholder : ''
      }, desiredProps, {
        dataHook: "inputWithTags-input",
        disabled: disabled,
        disableEditing: isSelectMode,
        onChange: function onChange(e) {
          if (!delimiters.includes(e.target.value)) {
            _this2.setState({
              inputValue: e.target.value
            });

            desiredProps.onChange && desiredProps.onChange(e);
          }
        },
        withSelection: true,
        prefix: this.props.customSuffix && !this.props.hideCustomSuffix && !this.state.inputHasFocus && /*#__PURE__*/React.createElement("span", {
          "data-hook": "custom-suffix",
          className: styles.customSuffix
        }, this.props.customSuffix)
      }))), (isSelectMode || status) && /*#__PURE__*/React.createElement("div", {
        className: suffixStyles
      }, /*#__PURE__*/React.createElement(InputSuffix, {
        disabled: disabled,
        status: status,
        statusMessage: statusMessage,
        menuArrow: isSelectMode
      })));
    }
  }, {
    key: "renderReorderableTag",
    value: function renderReorderableTag(_ref2) {
      var _classNames4;

      var _ref2$item = _ref2.item,
          id = _ref2$item.id,
          label = _ref2$item.label,
          itemProps = _objectWithoutProperties(_ref2$item, ["id", "label"]),
          previewStyles = _ref2.previewStyles,
          isPlaceholder = _ref2.isPlaceholder,
          isPreview = _ref2.isPreview,
          rest = _objectWithoutProperties(_ref2, ["item", "previewStyles", "isPlaceholder", "isPreview"]);

      var _this$props2 = this.props,
          onRemoveTag = _this$props2.onRemoveTag,
          disabled = _this$props2.disabled;
      var classes = classNames(styles.tag, (_classNames4 = {}, _defineProperty(_classNames4, defaultDndStyles.itemPlaceholder, isPlaceholder), _defineProperty(_classNames4, styles.draggedTagPlaceholder, isPlaceholder), _defineProperty(_classNames4, defaultDndStyles.itemPreview, isPreview), _defineProperty(_classNames4, styles.draggedTag, isPreview), _classNames4));
      return /*#__PURE__*/React.createElement("div", {
        style: previewStyles
      }, /*#__PURE__*/React.createElement(Tag, _extends({
        id: id,
        dataHook: "tag",
        disabled: disabled,
        className: classes,
        onRemove: onRemoveTag
      }, itemProps, rest), label));
    }
  }, {
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "select",
    value: function select() {
      this.input.select();
    }
  }, {
    key: "clear",
    value: function clear() {
      this.input.clear();
    }
  }]);

  return InputWithTags;
}(React.Component);

InputWithTags.propTypes = {
  onRemoveTag: PropTypes.func,
  tags: PropTypes.array,
  onReorder: PropTypes.func,
  maxHeight: PropTypes.string,
  maxNumRows: PropTypes.number,
  onKeyDown: PropTypes.func,
  dataHook: PropTypes.string,
  placeholder: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onInputClicked: PropTypes.func,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,

  /** The status of the input */
  status: PropTypes.oneOf(['error', 'warning', 'loading']),

  /** Text to be shown in the status icon tooltip */
  statusMessage: PropTypes.string,
  mode: PropTypes.oneOf(['select']),
  delimiters: PropTypes.array,
  width: PropTypes.string,
  customSuffix: PropTypes.node,
  hideCustomSuffix: PropTypes.bool
};
InputWithTags.defaultProps = {
  onRemoveTag: function onRemoveTag() {},
  tags: [],
  placeholder: '',
  delimiters: []
};
export default InputWithTags;